<template>
    <div class="news-detail" id="newsDetail" v-loading="loading">
        <div class="news-title">{{ news.title }}</div>
        <div class="news-info"><span style="margin-right: 30px;">来源：橙讯</span><span>{{ $tools.formatDate(news.publishTime) }}</span></div>
        <div id="newsBody" class="fr-view" v-if="news.bodyType == 0" v-html="news.body"></div>
        <iframe v-else style="border: none; width: 100%; height: calc(100% - 68px); min-height: 900px;" :src="news.body"></iframe>
    </div>
</template>

<script>
export default {
    name: 'NewsDetail',
    data() {
        return {
            loading: false,
            news: {},
            resourceCount: 0
        }
    },
    methods: {
        initPage() {
            this.loading = true
            this.$http({
                url: '/v1/content/itemById',
                method: 'get',
                params: {itemId: this.$route.query.itemId}
            }).then(res => {
                this.news = res
                if (res.bodyType == 0) {
                    this.$nextTick(() => {
                        const images = document.getElementById('newsBody').getElementsByTagName('img')
                        const videos = document.getElementById('newsBody').getElementsByTagName('video')
                        const totalNum = images.length + videos.length

                        this.resourceCount = 0
                        if (images.length > 0 || videos.length > 0) {
                            for (let i = 0; i < images.length; i++) {
                                images[i].onload = () => {
                                    this.resourceCount++
                                    if (this.resourceCount == totalNum) {
                                        this.refreshHeight()
                                    }
                                }
                                images[i].onerror = () => {
                                    this.resourceCount++
                                    if (this.resourceCount == totalNum) {
                                        this.refreshHeight()
                                    }
                                }
                            }
                            for (let i = 0; i < videos.length; i++) {
                                videos[i].onloadeddata = () => {
                                    this.resourceCount++
                                    if (this.resourceCount == totalNum) {
                                        this.refreshHeight()
                                    }
                                }
                                videos[i].onerror = () => {
                                    this.resourceCount++
                                    if (this.resourceCount == totalNum) {
                                        this.refreshHeight()
                                    }
                                }
                            }
                        } else {
                            this.refreshHeight()
                        }
                    })    
                } else {
                    this.loading = false
                }
                
            }).catch(err => {
                console.info(err)
                this.loading = false
            })
        },
        refreshHeight() {
            if (window.parent && window.parent.setIframeHeight) {
                const realHeight = document.getElementById('newsDetail').clientHeight
                window.parent.setIframeHeight(realHeight)
            }
            this.loading = false
        }
    },
    activated() {
        this.initPage()
    },
    deactivated() {
        this.news = {}
    }
}
</script>

<style lang="scss">
    .news-detail {
        box-sizing: border-box;
        padding: 24px; 

        .news-title {
            font-size: 24px;
        }

        .news-info {
            font-size: 13px;
            color: #666;
            margin-top: 8px;
            padding: 10px 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/news/Detail.vue